import styled from "styled-components";

export const CarouselContainer = styled.div`
  position: relative;
  width: 1200px;
  overflow: hidden;
  background: transparent;
  padding-bottom: 10px;
  margin: 0 auto;
`;

export const BannerWrapper = styled.div<{ currentIndex: number }>`
  display: flex;
  transition: transform 0.5s ease-in-out;
  transform: translateX(-${(props) => props.currentIndex * 100}%);
  will-change: transform;
  width: 1200px;
  height: 180px;
  border-radius: 8px;
`;

export const BannerSlide = styled.div`
  min-width: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DotsContainer = styled.div`
  display: flex;
  justify-content: center;
  bottom: 16px;
  gap: 8px;
`;

export const Dot = styled.button<{ active: boolean }>`
  width: ${(props) => (props.active ? "24px" : "8px")};
  height: 8px;
  border-radius: 4px;
  border: none;
  background-color: ${(props) =>
    props.active ? "#008CFF" : "rgba(255, 255, 255, 0.5)"};
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;

  &:hover {
    background-color: ${(props) =>
      props.active ? "#008CFF" : "rgba(255, 255, 255, 0.8)"};
  }

  &:focus {
    outline: 2px solid #008cff;
    outline-offset: 2px;
  }
`;

export const BannerContent = styled.img`
  object-fit: cover;
`;
